export const updateCompanyUrl = {
  companyUrl: null,
};

export const approveOrganizationDto = {
  organizationName: null,
  bid: null,
  volOrgId: null,
  regionCode: null,
  orgCountryCode: null,
  orgType: null,
  repFirstName: null,
  repAddressLineOne: null,
  repAddressLineTwo: null,
  repLastName: null,
  repCity: null,
  repState: null,
  repZipCode: null,
};

export const updateOrganizationDto = {
  repFirstName: null,
  repLastName: null,
  repCountryCode: null,
  repAddressLineOne: null,
  repAddressLineTwo: null,
  repCity: null,
  repState: null,
  repZipCode: null,
  repCountryPhoneCode: null,
  phoneNumber: null,
  companyUrl: null,
  hasConfirmedOrganizationBilling: null,
  hasAgreedTermsOfUse: null,
  isMerchant: false,
};
